import * as Yup from "yup";
import api from "../../globals/axios";

// Custom pincode validation schema
export const pincodeValidationSchema = Yup.string()
  .required("Pincode is required")
  .matches(/^\d{6}$/, "Pincode must be 6 digits")
  .test("valid-pincode", "Invalid Pincode", async (pincode) => {
    if (pincode && pincode.length === 6) {
      try {
        const response = await api.get(`common/pincode/${pincode}`);
        const postOfficesData = response.data[0]?.PostOffice || [];
        return postOfficesData.length > 0;
      } catch (error) {
        console.error("Error validating pincode:", error);
        return false;
      }
    }
    return false;
  });

export const validationSchema = Yup.object().shape({
  fpo_name: Yup.string().required("FPO Name is required"),
  contact_person: Yup.string().required("Contact Person is required"),
  mobile_no: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
    .required("Mobile Number is required"),
  number_of_farmers: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required("Number of Farmers is required")
    .positive("Number of Farmers must be positive")
    .integer("Number of Farmers must be an integer"),
  total_acreage: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .required("Total Acreage is required")
    .positive("Total Acreage must be positive"),
  crops: Yup.array()
    .min(1, "Select at least one crop")
    .required("Crops are required"),
  expected_crop_residue_kharif: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .nullable()
    .positive("Crop Residue must be positive"),
  expected_crop_residue_rabi: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .nullable()
    .positive("Crop Residue must be positive"),
  funding_source: Yup.string().required("Funding Source is required"),
  pin_code: pincodeValidationSchema,
  state: Yup.string().required("State is required"),
  district: Yup.string().required("District is required"),
  post_office: Yup.string().required("Post Office is required"),
  address_line1: Yup.string().required("Address is required"),
});
